import React from "react"
import { Section, Block, Note } from "../Sandbox"
import Raffle from "./"
import WithMockPiano from "../Piano/WithMockPiano"
import WithMockRaffle from "./WithMockRaffle"
import RaffleHolder from "./components/RaffleHolder"
import InitPlaceholder from "../embed/components/InitPlaceholder"
import { EmbedHolderCSSRoot, EmbedSurroundThatSetsThemedPageBackground } from "../embed/components/EmbedHolder"

const RaffleSandbox: React.FC = () => {
  return <EmbedSurroundThatSetsThemedPageBackground>
    <EmbedHolderCSSRoot>
      <Section title="Raffle">
        <Note>Raffle scenarios</Note>
        <Block>
          <WithMockPiano>
            <WithMockRaffle>
              <div style={{height: "16px"}} />
              <Raffle />
            </WithMockRaffle>
          </WithMockPiano>
        </Block>
        <Note>Piano init placeholder</Note>
        <Block>
          <RaffleHolder><InitPlaceholder /></RaffleHolder>
        </Block>
      </Section>
    </EmbedHolderCSSRoot>
  </EmbedSurroundThatSetsThemedPageBackground>
}

export default RaffleSandbox
